// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Skills list */
.skills__list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  align-items: flex-start;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: var(--spacing-base, 0.5rem);
}

.skills__item,
.skills__remove-button svg,
solid-ui-button.skills__remove-button {
  --skills-remove-icon-size: var(--icon-xxs, 1rem);
}

/* Skill chip */
.skills__item {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.375rem;
  padding: var(--spacing-base, 0.5rem) var(--spacing-2xs, 0.625rem);
  border-radius: var(--border-radius-base, 0.3125rem);
  background: var(--color-surface-chip, var(--gray-100, #F3F4F6));
  width: fit-content;
  max-width: 100%;
}

.skills__item[data-pending='true'] {
  opacity: 0.55;
}

.skills__item-label {
  display: inline;
  color: var(--color-text-strong, var(--slate-900, #0F172B));
  font-size: var(--font-size-sm, 0.875rem);
  font-weight: var(--font-weight-md, 500);
  line-height: 1.2;
  overflow-wrap: anywhere;
}

.skills__item-tail {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.skills__item-tail::before {
  content: '\\00a0';
}

.skills__empty-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Remove button */
solid-ui-button.skills__remove-button {
  width: var(--skills-remove-icon-size);
  height: var(--skills-remove-icon-size);
  line-height: 0;
  vertical-align: text-top;
  --button-height-sm: var(--skills-remove-icon-size);
  --button-padding-sm: 0;
  --button-icon-size-sm: var(--skills-remove-icon-size);
  --button-background: transparent;
  --button-border-width: 0;
  --button-border: transparent;
  --button-text: currentColor;
  --button-hover-background: transparent;
  --button-hover-border: transparent;
  --button-hover-text: currentColor;
}

solid-ui-button.skills__remove-button[data-loading='true'] {
  pointer-events: none;
}

.skills__remove-button svg {
  display: block;
  width: var(--skills-remove-icon-size);
  height: var(--skills-remove-icon-size);
}

.profile__section[data-profile-section='skills'] .profile-section-inline-error {
  margin-top: var(--spacing-sm, 0.938rem);
  padding: var(--spacing-xs, 0.75rem);
  border: 1px solid var(--dialog-error-border, var(--pink-700, #ff98b3));
  border-radius: var(--border-radius-base, 0.3125rem);
  background: var(--dialog-error-background, var(--pink-500, #ffdde6));
  color: var(--dialog-error-text, var(--red-600, #B00020));
  text-align: left;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .skills__list {
  align-items: flex-start;
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .skills__item {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.375rem;
  padding: var(--spacing-base, 0.5rem) var(--spacing-2xs, 0.625rem);
  width: fit-content;
  max-width: 100%;
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .skills__item-label {
  font-size: var(--font-size-sm, 0.875rem);
}

:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .skills__item-tail::before {
  content: none;
}

@media (max-width: 576px) {
  .skills__list {
    align-items: flex-start;
  }

  .skills__item {
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.375rem;
    padding: var(--spacing-base, 0.5rem) var(--spacing-2xs, 0.625rem);
    width: fit-content;
    max-width: 100%;
  }

  .skills__item-label {
    font-size: var(--font-size-sm, 0.875rem);
  }

  .skills__item-tail::before {
    content: none;
  }
}

@container profile-pane (max-width: 576px) {
  .skills__list {
    align-items: flex-start;
  }

  .skills__item {
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.375rem;
    padding: var(--spacing-base, 0.5rem) var(--spacing-2xs, 0.625rem);
    width: fit-content;
    max-width: 100%;
  }

  .skills__item-label {
    font-size: var(--font-size-sm, 0.875rem);
  }

  .skills__item-tail::before {
    content: none;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/sections/skills/SkillsSection.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gCAAgC;AAClC;;AAEA;;;EAGE,gDAAgD;AAClD;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,iEAAiE;EACjE,mDAAmD;EACnD,+DAA+D;EAC/D,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,0DAA0D;EAC1D,wCAAwC;EACxC,uCAAuC;EACvC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,qCAAqC;EACrC,sCAAsC;EACtC,cAAc;EACd,wBAAwB;EACxB,kDAAkD;EAClD,sBAAsB;EACtB,qDAAqD;EACrD,gCAAgC;EAChC,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,sCAAsC;EACtC,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,sEAAsE;EACtE,mDAAmD;EACnD,oEAAoE;EACpE,wDAAwD;EACxD,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,iEAAiE;EACjE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,iEAAiE;IACjE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,iEAAiE;IACjE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Skills list */\n.skills__list {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  align-items: flex-start;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  gap: var(--spacing-base, 0.5rem);\n}\n\n.skills__item,\n.skills__remove-button svg,\nsolid-ui-button.skills__remove-button {\n  --skills-remove-icon-size: var(--icon-xxs, 1rem);\n}\n\n/* Skill chip */\n.skills__item {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.375rem;\n  padding: var(--spacing-base, 0.5rem) var(--spacing-2xs, 0.625rem);\n  border-radius: var(--border-radius-base, 0.3125rem);\n  background: var(--color-surface-chip, var(--gray-100, #F3F4F6));\n  width: fit-content;\n  max-width: 100%;\n}\n\n.skills__item[data-pending='true'] {\n  opacity: 0.55;\n}\n\n.skills__item-label {\n  display: inline;\n  color: var(--color-text-strong, var(--slate-900, #0F172B));\n  font-size: var(--font-size-sm, 0.875rem);\n  font-weight: var(--font-weight-md, 500);\n  line-height: 1.2;\n  overflow-wrap: anywhere;\n}\n\n.skills__item-tail {\n  display: inline-flex;\n  align-items: center;\n  white-space: nowrap;\n}\n\n.skills__item-tail::before {\n  content: '\\00a0';\n}\n\n.skills__empty-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Remove button */\nsolid-ui-button.skills__remove-button {\n  width: var(--skills-remove-icon-size);\n  height: var(--skills-remove-icon-size);\n  line-height: 0;\n  vertical-align: text-top;\n  --button-height-sm: var(--skills-remove-icon-size);\n  --button-padding-sm: 0;\n  --button-icon-size-sm: var(--skills-remove-icon-size);\n  --button-background: transparent;\n  --button-border-width: 0;\n  --button-border: transparent;\n  --button-text: currentColor;\n  --button-hover-background: transparent;\n  --button-hover-border: transparent;\n  --button-hover-text: currentColor;\n}\n\nsolid-ui-button.skills__remove-button[data-loading='true'] {\n  pointer-events: none;\n}\n\n.skills__remove-button svg {\n  display: block;\n  width: var(--skills-remove-icon-size);\n  height: var(--skills-remove-icon-size);\n}\n\n.profile__section[data-profile-section='skills'] .profile-section-inline-error {\n  margin-top: var(--spacing-sm, 0.938rem);\n  padding: var(--spacing-xs, 0.75rem);\n  border: 1px solid var(--dialog-error-border, var(--pink-700, #ff98b3));\n  border-radius: var(--border-radius-base, 0.3125rem);\n  background: var(--dialog-error-background, var(--pink-500, #ffdde6));\n  color: var(--dialog-error-text, var(--red-600, #B00020));\n  text-align: left;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .skills__list {\n  align-items: flex-start;\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .skills__item {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.375rem;\n  padding: var(--spacing-base, 0.5rem) var(--spacing-2xs, 0.625rem);\n  width: fit-content;\n  max-width: 100%;\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .skills__item-label {\n  font-size: var(--font-size-sm, 0.875rem);\n}\n\n:is(.profile-pane-host, .profile-pane-root)[data-layout='mobile'] .skills__item-tail::before {\n  content: none;\n}\n\n@media (max-width: 576px) {\n  .skills__list {\n    align-items: flex-start;\n  }\n\n  .skills__item {\n    display: inline-flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 0.375rem;\n    padding: var(--spacing-base, 0.5rem) var(--spacing-2xs, 0.625rem);\n    width: fit-content;\n    max-width: 100%;\n  }\n\n  .skills__item-label {\n    font-size: var(--font-size-sm, 0.875rem);\n  }\n\n  .skills__item-tail::before {\n    content: none;\n  }\n}\n\n@container profile-pane (max-width: 576px) {\n  .skills__list {\n    align-items: flex-start;\n  }\n\n  .skills__item {\n    display: inline-flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 0.375rem;\n    padding: var(--spacing-base, 0.5rem) var(--spacing-2xs, 0.625rem);\n    width: fit-content;\n    max-width: 100%;\n  }\n\n  .skills__item-label {\n    font-size: var(--font-size-sm, 0.875rem);\n  }\n\n  .skills__item-tail::before {\n    content: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
